module.exports = __webpack_public_path__ + "static/media/solo49.a4fa7c03.JPG";